import { ref, computed, onMounted } from 'vue'

export function useElement(props): any {
  const fieldRef = ref()

  const isReadOnly = (field) => {
    return field && field.readonly ? true : false
  }

  const fieldName = computed(() => {
    if (props.definitionField.field.form) {
      if (props.definitionField.field.group && props.definitionField.field.group.name) {
        return `${props.definitionField.field.form}[${props.definitionField.field.group.name}][${props.definitionField.field.name}]`
      }

      return `${props.definitionField.field.form}[${props.definitionField.field.name}]`
    }

    return props.definitionField.field.name
  });

  const addonsPre = computed(() => {
    const addons: any[] = []

    if (
      props.definitionField.field.addons &&
      props.definitionField.field.addons.length > 0
    ) {
      for (const addon of props.definitionField.field.addons) {
        if (addon.type === "pre") {
          addons.push(addon)
        }
      }
    }

    return addons
  });

  const addonsPost = computed(() => {
    const addons: any[] = []

    if (
      props.definitionField.field.addons &&
      props.definitionField.field.addons.length > 0
    ) {
      for (const addon of props.definitionField.field.addons) {
        if (addon.type === "post") {
          addons.push(addon)
        }
      }
    }

    return addons
  });

  const fieldLookup = computed(() => {
    return props.dataLookup ? props.dataLookup.values : []
  });

  const fieldPlaceholder = computed(() => {
    const placeholderSelectOne = props.definitionField.field?.placeholder_select ?? "-- Bitte auswählen --"
    const placeholderSelectAll = props.definitionField.field?.placeholder_select_search ?? "-- Alle anzeigen --"

    return props.dropdownmode === "choose"
      ? placeholderSelectOne
      : placeholderSelectAll
  })

  const fieldPlaceholderNoOptions = computed(() => {
    return props.definitionField.field?.placeholder_no_options ?? "Keine Optionen gefunden."
  });

  const fieldId = computed(() => {
    return props.definitionField.id.toString()
  });

  const mapLookupToEntities = (lookup, type) => {
    const entities: any[] = []

    if (type === "grid") {
      for (const row of lookup.values) {
        const newrow: any[] = []
        for (const col of row) {
          newrow.push({
            id: fieldName.value + col.text,
            name: fieldName.value,
            value: col.value,
            label: col.text
          })
        }
        entities.push(newrow)
      }
    } else {
      for (const entry of lookup.values) {
        entities.push({
          id: fieldName.value + entry.text,
          name: fieldName.value,
          value: entry.value,
          label: entry.text
        })
      }
    }

    return entities
  }

  const mapLookupToRadios = computed(() => {
    return mapLookupToEntities(props.dataLookup, props.definitionField.field.render)
  })

  const mapLookupToCheckboxes = computed(() => {
    return mapLookupToEntities(props.dataLookup, props.definitionField.field.render)
  })

  const columnWidthEntity = (map, type) => {
    let count = 0

    if (type === "grid") {
      for (const row of map) {
        if (row.length > count) count = row.length
      }
    } else {
      count = type === 'inline' ? map.length : 1
    }

    return 100 / count
  }

  const columnWidthRadios = computed(() => {
    return columnWidthEntity(mapLookupToRadios.value, props.definitionField.field.render)
  })

  const columnWidthCheckboxes = computed(() => {
    return columnWidthEntity(mapLookupToCheckboxes.value, props.definitionField.field.render)
  })

  const generateDataAttributes = computed(() => {
    const data = {}
    if (props?.definitionField.field.widget?.data && typeof props?.definitionField.field.widget?.data === 'object') {
        for (const d of Object.keys(props.definitionField.field.widget.data)) {
          const kebabCaseKey = d.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase()
          data["data-" + kebabCaseKey] = props.definitionField.field.widget.data[d]
      }
    }
    return data
  })

  const generateValidationObject = computed(() => {
    const data = {}

    if (!("checks" in props.definitionField.field.validation)) return {}

    for (const v of Object.keys(props.definitionField.field.validation.checks)) {
      const s = props.definitionField.field.validation.checks[v].split(":")
      if (s.length === 2) {
        data[s[0]] = s[1]
      }
    }

    return data
  })

  const validationStatus = computed(() => {
    return ""
  })

  const labelHasInfo = computed(() => {
    return (props.definitionField?.field?.info ?? undefined) !== undefined
  })

  return {
    fieldRef,
    isReadOnly,
    onMounted,
    fieldName,
    addonsPre,
    addonsPost,
    fieldLookup,
    fieldPlaceholder,
    fieldPlaceholderNoOptions,
    fieldId,
    mapLookupToCheckboxes,
    columnWidthCheckboxes,
    mapLookupToRadios,
    columnWidthRadios,
    generateDataAttributes,
    generateValidationObject,
    validationStatus,
    labelHasInfo
  }
}
